
import { scrollTo } from '../../../../application/typescript/utils/utils';


class HeadingEvenement {
  constructor() {
    this._init();
  }

  _init() {
    const scrollOnClick = (triggerSelector: string, targetSelector: string) => {
      const trigger = document.querySelector(triggerSelector);

      const allTargets = document.querySelectorAll(targetSelector);

      if (trigger && allTargets.length > 0) {

        const lastTarget = allTargets[allTargets.length - 1] as HTMLElement;

        trigger.addEventListener('click', (event: Event) => {
          event.preventDefault();

          scrollTo(lastTarget);
        });
      }
    };


    scrollOnClick('[data-evenement-more]', '.evenement-more');
    scrollOnClick('[data-evenement-prices]', '.evenement-prices');

    // Add Calendar
    const button = document.querySelector('[data-evenement-calendar]') as HTMLButtonElement;

    if (!button) return;

    button.addEventListener('click', (e) => {
      e.preventDefault();

      const title = button.getAttribute('data-evenement-title') || 'Événement';
      const details = button.getAttribute('data-evenement-details') || '';
      const location = button.getAttribute('data-evenement-location') || '';
      const date = button.getAttribute('data-evenement-date') || ''; // Format : YYYYMMDD
      const startTime = button.getAttribute('data-evenement-debut') || '09:00:00'; // Format : HH:mm:ss
      const endTime = button.getAttribute('data-evenement-fin') || '17:00:00';

      const formatTime = (time: string) => time.replace(/:/g, '').slice(0, 6); // "13:00:00" → "130000"
      const dtStart = `${date}T${formatTime(startTime)}`;
      const dtEnd = `${date}T${formatTime(endTime)}`;

      const icsContent = `
BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//TonSite//Agenda//FR
BEGIN:VEVENT
UID:${Date.now()}@tonsite.com
DTSTAMP:${date}T000000Z
DTSTART:${dtStart}
DTEND:${dtEnd}
SUMMARY:${title}
DESCRIPTION:${details}
LOCATION:${location}
END:VEVENT
END:VCALENDAR
    `.trim();

      const blob = new Blob([icsContent], { type: 'text/calendar' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `${title.replace(/\s+/g, '_')}.ics`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    });
  }
}

export const headingEvenement = new HeadingEvenement();
